<div *ngIf="successMessage" class="alert alert-success" role="alert">
    <mat-icon style="vertical-align: text-bottom; height: 20px; width: 20px; font-size: 20px;">thumb_up</mat-icon>
    &nbsp;
    <label style=" vertical-align: text-bottom; margin-bottom: 0rem;">
        {{successMessage}}
    </label>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <mat-icon style="vertical-align: text-bottom; height: 20px; width: 20px; font-size: 20px;">thumb_down</mat-icon>
    &nbsp;
    <label style=" vertical-align: text-bottom; margin-bottom: 0rem;">
        {{errorMessage}}
    </label>
</div>


<div *ngIf="checkCommonMessage() && (successMessage == '' || !successMessage) && (errorMessage == ''|| !errorMessage)"
    class="alert alert-info" role="alert">
    <label style=" vertical-align: text-bottom; margin-bottom: 0rem;">
        {{CommonMessage}}
    </label>
</div>

<div *ngIf="complianceComp && Complianerror" class="alert alert-danger alret1" role="alert">
    <div>
        <svg class="close0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
            <path
                d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
        </svg>
        <label style=" vertical-align: text-bottom; margin-bottom: 0rem;" class="compl">
            {{Complianerror}}
        </label>
    </div>
    <div class="close" (click)="close()">
        <svg class="close1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
            <path
                d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" />
        </svg>
    </div>

</div>